import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Calendar } from "react-date-range";

const DateCalendar = props => {

  const settings = {
    ...(props?.maxDate && {
      maxDate: new Date(props.maxDate),
    })
  }

  return (
    <StyledCalendar
      id={`drop-down-calendar`}
      onChange={item => props.onChange(item)}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      ranges={props.state.length > 0 && props.state}
      direction={"vertical"}
      date={props.date}
      showDateDisplay={false} // Hide date display
      styledStyle={props.style}
      minDate={new Date("2000-01-01")}
      {...settings}
    />
  );
};

const StyledCalendar = styled(Calendar)`
  position: absolute;
  z-index: 999999;
  left: ${options => (options.styledStyle.right > 1000 ? "auto" : "0")};
  right: ${options => (options.styledStyle.right > 1000 ? "0" : "auto")};
  border: 1px solid rgba(0, 0, 0, 0.1);
  top: ${options =>
    options.styledStyle.bottom < 400
      ? "75px"
      : options.styledStyle.width < 1700
        ? "-277px"
        : "-277px"};
  border-radius: 5px 0px 5px 5px;

  .rdrDefinedRangesWrapper {
    border-radius: 5px 0px 0px 5px;
    transition-duration: 0.5s;

    display: ${options =>
    options.styledStyle.width > 1131 ? "block" : "none"};

    .rdrStaticRanges {
      border-top-left-radius: 5px;

      .rdrStaticRange {
        span {
          color: #495057;
          font-family: "Poppins", sans-serif;
          font-weight: 400;
          font-size: 13px;
        }
      }
      .rdrStaticRangeSelected {
        span {
          color: #3d91ff;
        }
      }
      .rdrStaticRange:nth-child(1) {
        border-top-left-radius: 5px;
        .rdrStaticRangeLabel:nth-child(1) {
          border-top-left-radius: 5px;
        }
      }
    }
    .rdrInputRanges {
      .rdrInputRange {
        span {
          width: 50%;
          font-size: 8.5px;
          color: #495057;
          font-weight: 500;
          font-family: "Poppins", sans-serif;
        }
      }
    }
  }

  .rdrCalendarWrapper {
    border-radius: ${options =>
    options.styledStyle.width > 610 ? "5px 0px 5px 0px" : "5px 0px 5px 5px"};

    .rdrDateDisplayWrapper {
      border-top-left-radius: ${options =>
    options.styledStyle.width > 610 ? "0" : "5px"};

      .rdrDateDisplay {
        .rdrDateInput {
          input {
            border-radius: 4px;
          }
        }
      }
    }
  }

  &::after {
    content: "";
    ${"" /* top: -13px; */}
    top: ${options =>
    options.styledStyle.bottom < 400
      ? "-13px"
      : options.styledStyle.width < 1700
        ? "293px"
        : "293px"};
    transform: ${options =>
    options.styledStyle.bottom < 400 ? "rotate(0deg)" : "rotate(180deg)"};
    left: ${options => (options.styledStyle.right > 1000 ? "auto" : "3px")};
    right: ${options => (options.styledStyle.right > 1000 ? "3px" : "auto")};
    position: absolute;
    border: 6px solid transparent;
    border-bottom: 6px solid rgba(0, 0, 0, 0.1);
  }
`;

DateCalendar.propTypes = {
  style: PropTypes.object,
  state: PropTypes.any,
  date: PropTypes.any,
  onChange: PropTypes.func,
  maxDate: PropTypes.string
};

export default DateCalendar;
